import React, { useState, useEffect } from 'react';
import './styles.css';

const Skills = ({ isDarkMode }) => {
    // Throw an error if isDarkMode prop isn't provided
    if (isDarkMode === undefined) {
        throw new Error('isDarkMode prop is required for Skills component');
    }

    const [skillsData, setSkillsData] = useState(null);

    useEffect(() => {
        fetch('/data/skills.json')
            .then(response => response.json())
            .then(data => setSkillsData(data))
            .catch(error => console.error('Error fetching skills data:', error));
    }, []);

    const scrollToProjects = () => {
        const projectsSection = document.getElementById('projects');
        if (projectsSection) {
            projectsSection.scrollIntoView({ behavior: 'smooth' });
        }
    };

    if (!skillsData) {
        return <div>Loading...</div>;
    }

    return (
        <div className="mainArea transition-effect" id="skills">
            <div className="skills transition-effect">
                <div className="leftArea">
                    <img
                        src="/images/siteElements/topImg.jpeg"
                        alt="Skills Top"
                        className="topImg"
                    />

                    <div className="contentArea">
                        <div className="leftContent">
                            <div className="sectionTitle">
                                Skills
                            </div>

                            <img
                                src="/images/siteElements/scroll-both.png"
                                alt="Scroll Both Indicator"
                                className="skillScrollBoth"
                                onClick={scrollToProjects}
                                style={{ cursor: 'pointer' }}
                            />
                        </div>
                        <div className="rightContent">
                            <div className="skills-list-container">
                                {Object.entries(skillsData).map(([category, skills]) => (
                                    <div className="skills-category" key={category}>
                                        <h3 className="skills-category-title">{category}</h3>
                                        <ul className="skills-items">
                                            {skills.map((skill) => (
                                                <li key={skill} className="skill-item">{skill}</li>
                                            ))}
                                        </ul>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="rightArea">
                    <img
                        src="/images/siteElements/topImg.jpeg"
                        alt="Skills Right"
                        className="rightImg"
                    />
                </div>
            </div>
        </div>
    );
};

export default Skills;